<template>
  <div
    class="user-avatar-badge"
    :class="[marginClass, badgeVariantClass]"
  >
    <span
      v-if="isSystem"
      :aria-label="systemAriaLabel"
    >
      🤖
    </span>
    <span v-else>
      {{ initials }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'UserAvatarBadge',
  props: {
    name: {
      type: String,
      default: '',
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    marginClass: {
      type: String,
      default: 'mr-3',
    },
    light: {
      type: Boolean,
      default: false,
    },
    systemAriaLabel: {
      type: String,
      default: 'System',
    },
  },
  computed: {
    badgeVariantClass() {
      if (this.isSystem) {
        return 'bg-gray text-white';
      }
      if (this.light) {
        return 'badge-light';
      }
      return 'bg-light text-secondary';
    },
    initials() {
      const names = (this.name || '')
        .split(' ')
        .filter((entry) => entry.length > 0)
        .slice(0, 2);
      if (!names.length) {
        return 'SY';
      }
      return names.map((entry) => entry.charAt(0).toUpperCase()).join('');
    },
  },
};
</script>

<style scoped>
.user-avatar-badge {
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
}
</style>
